import { createContext, useState } from "react";

type Nav = {
    title?: string
}

type NavContext = {
    setNav: React.Dispatch<React.SetStateAction<Nav>>
    nav: Nav
}

const NavContext = createContext<NavContext | null>(null);

export const NavProvider = ({ children } : { children:React.ReactNode}) => {
    const [nav, setNav] = useState<Nav>({
        title: 'Startpagina'
    });

    return (
        <NavContext.Provider value={{ nav, setNav }}>
            {children}
        </NavContext.Provider>
    )
}

export default NavContext;